export const GET_SHOW_AVAILABILITY_BEGIN = "GET_SHOW_AVAILABILITY_BEGIN"
export const GET_SHOW_AVAILABILITY_SUCCESS = "GET_SHOW_AVAILABILITY_SUCCESS"
export const GET_SHOW_AVAILABILITY_ERROR = "GET_SHOW_AVAILABILITY_ERROR"
